export const hotList = [
  {
    rank: 1,
    title: '某顶流男星被曝深夜密会神秘女子，工作室尚未回应',
    category: '明星绯闻',
    heat: '986万',
    summary: '多位网友称在同一商圈连续两晚目击该艺人，相关话题短时间内冲上讨论榜前列，目前仅有代拍流出画面，真实性仍待确认。',
  },
  {
    rank: 2,
    title: '头部带货主播直播间翻车，售后承诺被指货不对板',
    category: '网红黑料',
    heat: '871万',
    summary: '有消费者整理出近期多笔订单截图，反映赠品规格与口播描述存在出入，主播团队暂未给出统一说明。',
  },
  {
    rank: 3,
    title: '综艺同框引热议：两位旧搭档疑似和好，现场互动被反复解读',
    category: '吃瓜现场',
    heat: '754万',
    summary: '最新一期节目里两人被安排到同一环节，一个递水的动作被观众放大讨论，评论区出现多种解读。',
  },
  {
    rank: 4,
    title: '人气女团成员被曝行程临时取消，官方以档期调整回应',
    category: '明星绯闻',
    heat: '689万',
    summary: '原定的线下见面会前一晚突然改期，粉丝在超话集中询问原因，工作室仅回复“档期调整”四字。',
  },
  {
    rank: 5,
    title: '短视频博主被指搬运他人创意，原作者晒出时间线',
    category: '网红黑料',
    heat: '612万',
    summary: '原作者贴出草稿与发布时间对比，认为分镜高度相似；涉事博主回应称属“各自独立创作”。',
  },
  {
    rank: 6,
    title: '热播剧番位之争再升级，片方悄悄调整海报排序',
    category: '吃瓜现场',
    heat: '548万',
    summary: '有细心观众对比新旧物料，发现演员署名顺序发生变化，粉丝随即展开新一轮讨论。',
  },
  {
    rank: 7,
    title: '某音乐人被传即将官宣巡演，票务平台已出现预热页面',
    category: '演出动态',
    heat: '467万',
    summary: '票务平台出现尚未开放的巡演页面截图，主办方未确认，粉丝提醒注意辨别非官方渠道信息。',
  },
  {
    rank: 8,
    title: '情侣艺人被拍同框逛街，经纪人回应“只是朋友聚会”',
    category: '明星绯闻',
    heat: '402万',
    summary: '两人被拍到一前一后进入同一商场，随行还有多位工作人员，经纪人否认恋爱传闻。',
  },
];